export default __webpack_public_path__ + "static/media/ponente-Hector.64ee339c.png";